import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { ConfiguracoesService } from "./api-configuracoes.service";
import { PerfilUsuarioSignature } from "../../models/signature/perfilUsuarioSignature";
import { AtualizarSenhaPerfilUsuarioSignature } from "../../models/signature/AtualizarSenhaPerfilUsuarioSignature";
import { AtualizarAtalhoSignature } from "../../models/signature/AtualizarAtalhoSignature";

@Injectable({
  providedIn: 'root'
})

export class ConfiguracoesDataService {

  private atalhosAtualizados$ = new Subject<void>();

  /** Emitido quando os atalhos do assistente virtual são alterados nas configurações. */
  get AtalhosAtualizados(): Observable<void> {
    return this.atalhosAtualizados$.asObservable();
  }

  /** Chame após atualizar atalho para o assistente virtual recarregar a lista. */
  public notificarAtalhosAtualizados(): void {
    this.atalhosAtualizados$.next();
  }

  constructor(private api: ConfiguracoesService) {
  }

  public CarregarListaDeTelas(): Observable<any> {
    return this.api.CarregarListaDeTelas();
  }

  public CarregarListaAtalhos(): Observable<any> {
    return this.api.CarregarListaAtalhos();
  }

  public AtualizarTelaAtalho(signature: AtualizarAtalhoSignature): Observable<any> {
    return this.api.AtualizarTelaAtalho(signature);
  }
}
